import React from "react";
import Dropdown from "./Dropdown/Dropdown";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import useFetchData from "../../hooks/useFetchData";
import { useModalContext } from "../../context/ModalContext";

const FromTokenDropdown = ({ selected, onSelect, options, setOptions }) => {
  const { getUserConfirmationForDelete } = useModalContext();
  const handleCreateOption = async (newName) => {
    try {
      const { data } = await axiosInstance.post("/from_token", { name: newName });
      setOptions((prev) => [...prev, data]);
      return data;
    } catch (error) {
      handleApiError(error);
    }
  };
  const handleDeleteFromToken = async (id) => {
    try {
      const userConfirmed = await getUserConfirmationForDelete();
      if (!userConfirmed) return;

      await axiosInstance.delete(`/from_token/${id}`);
      setOptions((pre) => pre.filter((t) => t.id !== id));
    } catch (error) {
      handleApiError(error);
    }
  };
  return (
    <Dropdown
      options={options}
      selected={selected}
      onSelect={onSelect}
      onCreate={handleCreateOption}
      onDelete={handleDeleteFromToken}
      placeholder="Type or select from token"
    />
  );
};

const FromTokenDropdownWithFetch = ({ selected, onSelect }) => {
  const { data, setData, error, loading } = useFetchData(`/from_token`);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Error while feching from token</div>;
  }
  return (
    <FromTokenDropdown
      selected={typeof selected === "string" ? data.find((o) => o.id === selected) : selected}
      onSelect={onSelect}
      options={data}
      setOptions={setData}
    />
  );
};

export default FromTokenDropdown;
export { FromTokenDropdownWithFetch };
